var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 74,
    viewBox: "0 0 68 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 73.9999V60.6666H67.3334V73.9999H0.666748ZM7.33342 54V41.5L37.5001 11.3333L50.0001 23.8333L19.8334 54H7.33342ZM53.7501 20.1666L41.2501 7.66662L47.2501 1.66662C47.8612 0.999949 48.639 0.67995 49.5834 0.706617C50.5279 0.735505 51.3056 1.05551 51.9168 1.66662L59.7501 9.49995C60.3612 10.1111 60.6668 10.8755 60.6668 11.7933C60.6668 12.7088 60.3612 13.5 59.7501 14.1666L53.7501 20.1666Z",
    fill: "#FAAA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.507fb3b1d5f7b0265622b6705338d137.svg";
export { ForwardRef as ReactComponent };